/**
 * inputWhenDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { toSqlDateTime } from '@shared/utils';
import { isSameDay } from '@shared/utils/datetime';
import { isFunction } from 'lodash-es';
import moment from 'moment';

inputWhenDirective.$inject = ['$util'];

export function inputWhenDirective($util) {
    return {
        restrict: 'E',
        //language=HTML
        template: `
            <div class="form-row">
                <app-input-date class="flex-30"
                                label="Date"
                                form="form"
                                name="start_date"
                                value-date="valueCopy.start"
                                change="_onStartChange()"
                                ng-disabled="disabled"
                                required="required">
                </app-input-date>

                <app-input-time class="flex-30"
                                label="Start"
                                form="form"
                                name="start"
                                value-date="valueCopy.start"
                                change="_onStartChange()"
                                ng-disabled="disabled"
                                required="required">
                </app-input-time>

                <app-input-duration class="flex-10"
                                    label="Duration"
                                    form="form"
                                    name="duration"
                                    value="valueCopy.duration"
                                    show-hint="false"
                                    change="_onDurationChange()"
                                    ng-disabled="disabled"
                                    required="required">
                </app-input-duration>

                <app-input-time class="flex-30"
                                form="form"
                                name="finish_time"
                                label="Finish"
                                value-date="valueCopy.finish"
                                change="_onFinishChange()"
                                ng-disabled="disabled"
                                required="required">
                </app-input-time>
            </div>

            <app-alert info icon="calendar_today" ng-if="!isSameDay && isNextDay">
                Finishes the following day.
            </app-alert>

            <app-alert info icon="calendar_today" ng-if="!isSameDay && !isNextDay">
                Finishes on {{ valueCopy.finish | appDate }}
            </app-alert>
        `,
        scope: {
            form: '=?form',
            dispatchChange: '&?change',
            disabled: '=ngDisabled',
            required: '=?required',
            value: '=value',
        },
        link: function (scope, element, attrs) {
            scope.valueCopy = {};
            scope.isSameDay = false;
            scope.isNextDay = false;

            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            scope.$watch('value', value => {
                if (value?.start) {
                    // Don't update the local copy if input has started.
                    scope.valueCopy = {
                        start: moment.utc(value.start).toDate(),
                        finish: moment
                            .utc(value.start)
                            .add(value.duration, 'seconds')
                            .toDate(),
                        duration: value.duration,
                    };
                }
            });

            scope.$watch(
                'valueCopy',
                value => {
                    if (value?.start && !scope.standalone) {
                        if (!scope.value) {
                            scope.value = {};
                        }

                        scope.value.start = toSqlDateTime(value.start, true);
                        scope.value.duration = value.duration ?? 0;

                        scope.isSameDay = isSameDay(scope.valueCopy.start, scope.valueCopy.finish);
                        scope.isNextDay = isSameDay(scope.valueCopy.finish, moment.utc(value).add(1, 'day').toDate());

                        _dispatchChange();
                    }
                },
                true,
            );

            scope._onStartChange = $util.nextTick(_onStartChange);
            scope._onFinishChange = $util.nextTick(_onFinishChange);
            scope._onDurationChange = $util.nextTick(_onDurationChange);

            function _onStartChange() {
                scope.valueCopy.finish = moment
                    .utc(scope.valueCopy.start)
                    .add(scope.valueCopy.duration, 'seconds')
                    .toDate();
            }

            function _onDurationChange() {
                scope.valueCopy.finish = moment
                    .utc(scope.valueCopy.start)
                    .add(scope.valueCopy.duration, 'seconds')
                    .toDate();
            }

            function _onFinishChange() {
                // Update the duration
                scope.valueCopy.duration = moment
                    .utc(scope.valueCopy.finish)
                    .diff(moment.utc(scope.valueCopy.start), 'seconds');
            }

            function _dispatchChange() {
                if (isFunction(scope.dispatchChange)) {
                    scope.dispatchChange();
                }
            }
        },
    };
}
